export const BATCH_R_URL = 'https://r.stripe.com/b';
export const BATCH_QA_R_URL = 'https://qa-r.stripe.com/b';
export const METRICS_R_URL = 'https://r.stripe.com/m';
export const METRICS_QA_R_URL = 'https://qa-r.stripe.com/m';
